export default {
  __html: `<g fill="#292663" fill-rule="evenodd">
                <path d="M71.77,84.56a3.06,3.06,0,0,1-3.06-3.06V25.56a3.07,3.07,0,0,0-3.06-3.06H37.09A3.07,3.07,0,0,0,34,25.56V81.5a3.06,3.06,0,0,1-6.13,0V25.56a9.2,9.2,0,0,1,9.19-9.19H65.64a9.2,9.2,0,0,1,9.19,9.19V81.5A3.06,3.06,0,0,1,71.77,84.56Z"/>
                <path d="M83,85.79H19.63a3.06,3.06,0,0,1,0-6.13H83a3.06,3.06,0,0,1,0,6.13Z"/>
                <path d="M61.35,49H40.79a3.06,3.06,0,0,1,0-6.13H61.35a3.06,3.06,0,0,1,0,6.13Z"/>
                <path d="M76.84,73.61H71.9a3.06,3.06,0,0,1,0-6.13h4.94a3.07,3.07,0,0,0,3.06-3.06V39.1l-4.33-4.33H71.9a3.06,3.06,0,1,1,0-6.13h4.94a3.06,3.06,0,0,1,2.17.9l6.13,6.13a3.06,3.06,0,0,1,.9,2.17V64.42A9.2,9.2,0,0,1,76.84,73.61Z"/>
                <rect width="102.13" height="102.13" style="fill:none"/>
            </g>`
}
